import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const AnchorLinks = ({
  anchorLinks, // field_anchor_links
  paragraphs, // field_paragraphs
}) => {
  const { t } = useTranslation();

  return (
    <div className="AnchorLinks">
      <h4>{t('general.quickly_to')}</h4>
      {anchorLinks.map((link) => {
        const [linkId, ...linkText] = link.value.split(' ');
        const paragraph = paragraphs.find((paragraph) => paragraph.target_id === Number(linkId));

        return (
          <a className="AnchorLinks__link" href={`#${linkId}`}>
            <div>
              <i className="icon icon-arrow-down icon-variant-2" />
            </div>
            {linkText.length
              ? linkText.join(' ')
              : paragraph.entity.field_title?.[0]?.value
                ? paragraph.entity.field_title?.[0]?.value
                : linkId}
          </a>
        );
      })}
    </div>
  );
};

export default AnchorLinks;
